export const header: HeaderSetup = {
    background: 'linear-gradient(137deg, #FFF 260px, transparent 260px), #ffe6b4',
    backgroundMobile: '#ffe6b4',
    foreground: null,
    logo: '/assets/kromatic-black.svg',
    logoLink: null,
    logoMobile: '/favicon.png',
    tagline: 'Find the Right Sample Size and Spot the Winner in A/B Tests',
    textOffset: 115,
    title: 'Experiment Calculator',
};
